/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {Formik} from 'formik'
import useUtils from './useUtils'
import {useNavigate} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {setTitle} from '../../redux/reducers/mainSlice'

const AddLanguage = () => {
  const dispatch = useDispatch()
  dispatch(setTitle('Language'))
  const navigate = useNavigate()
  const {submitLanguage} = useUtils()
  const initialValues = {
    name: '',
    code: ''
  }

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Please enter name'),
    code: Yup.string().required('Please enter code'),
  })

  const handleSubmit = (values) => {
    submitLanguage(values)
  }

  return (
    <>
      <div className='card card-custom'>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({values, touched, errors, handleChange, handleSubmit}) => (
            <form className='form' onSubmit={handleSubmit}>
              <div className='card-body'>
                <div className='tab-content pt-3'>
                  {/* end::Body */}
                  <div className='row align-items-center flex-wrap'>
                    <div className='col-lg-8'>
                      <label className='col-form-label required fw-bold fs-6'>Title</label>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder='Enter Language Name'
                        name='name'
                        value={values.name}
                        onChange={handleChange}
                      />
                      {touched.name && errors.name && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className='text-danger'>
                            {errors.name}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='row align-items-center flex-wrap mt-2'>
                    <div className='col-lg-6'>
                      <label className='col-form-label required fw-bold fs-6'>Code</label>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder='Enter Language Code'
                        name='code'
                        value={values.code}
                        onChange={handleChange}
                      />
                      {touched.code && errors.code && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className='text-danger'>
                            {errors.code}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div>{/* end::Body */}</div>
              {/* end::Body */}
              <div className='row'>
                <div className=' col-lg-12 d-flex align-items-center justify-content-end my-5'>
                  <button
                    type='button'
                    className='btn btn-danger ms-2 mt-2 me-2'
                    onClick={() => navigate('/languagelist')}
                  >
                    Cancel
                  </button>
                  <button type='submit' className='btn btn-primary ms-2 mt-2 me-2'>
                    Submit
                  </button>
                </div>
              </div>
            </form>
          )}
        </Formik>
        {/* end::Form */}
      </div>
    </>
  )
}

export default AddLanguage
